<div class="container-fluid pt-2 astro-lum-dashboard">
  <div class="row g-3 align-items-stretch h-100">

    <div class="col-xl-8 col-lg-7 col-12 d-flex flex-column gap-3">

      <div class="row g-3 align-items-stretch flex-shrink-0">
        <div class="col-md-6 d-flex">
          <div class="card h-100 w-100">
            <div class="card-header py-2">
              <h6 class="card-title mb-0">{{ 'deviceInfo' | translate }}</h6>
            </div>
            <div class="card-body py-3 d-flex flex-column justify-content-center gap-3">
              <div>
                <i class="fas fa-wifi fs-5 me-1" [class.text-success]="deviceInfo?.alive"
                  [class.text-danger]="deviceInfo?.alive === false"></i>
                <strong class="small">{{ deviceInfo?.alive ? ('connected' | translate) : ('disconnected' | translate) }}</strong>
              </div>
              <div>
                <i class="fas fa-history text-info me-1"></i>
                <strong class="small">{{ 'lastConnection' | translate }}:</strong>
                <small class="text-muted ms-1">{{ lastConnection ? (lastConnection | date:'medium') : '--' }}</small>
              </div>
              <div>
                <i class="fas fa-clock text-warning me-1"></i>
                <strong class="small">{{ 'timezone' | translate }}:</strong>
                <small class="text-muted ms-1">{{ timeZone || '--' }}</small>
              </div>
              <div>
                <i class="fas fa-map-marker-alt text-danger me-1"></i>
                <strong class="small">{{ 'location' | translate }}:</strong>
                <small class="text-muted ms-1">{{ ubicacion?.city || '--' }}, {{ ubicacion?.country || '--' }}</small>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 d-flex">
          <div class="card h-100 w-100">
            <div class="card-header py-2">
              <h6 class="card-title mb-0">{{ 'outputsState' | translate }}</h6>
            </div>
            <div class="card-body py-3 d-flex align-items-center">
              <div class="row g-0 align-items-center w-100">
                <div class="col-6">
                  <div class="data-item text-center px-2">
                    <div class="data-icon mx-auto mb-2"
                      [ngClass]="isOutputOn === true ? 'bg-warning bg-opacity-10' : 'bg-secondary bg-opacity-10'">
                      <div class="spinner-border text-primary" role="status" *ngIf="outputLoading" style="height: 16px; width: 16px;">
                        <span class="visually-hidden">{{ 'loading' | translate }}</span>
                      </div>
                      <ng-container *ngIf="!outputLoading">
                        <i class="fas fa-lightbulb text-muted" *ngIf="isOutputOn !== true"></i>
                        <i class="fas fa-lightbulb text-warning-2" *ngIf="isOutputOn === true"></i>
                      </ng-container>
                    </div>
                    <div class="small fw-bold text-primary d-inline-flex align-items-center justify-content-center gap-1 mb-2">
                      {{ 'output1' | translate }}
                      <i class="fa-solid fa-lock text-warning" *ngIf="isPermanentLocked === true"></i>
                      <i class="fa-solid fa-unlock text-secondary" *ngIf="isPermanentLocked === false"></i>
                    </div>
                    <div class="d-flex justify-content-center">
                      <div (click)="toggleOutput()"
                        [ngClass]="isOutputOn === true
                          ? 'd-flex align-items-center justify-content-center fw-bold rounded-2 border border-2'
                          : 'border border-secondary border-2 bg-light text-muted rounded-2 d-flex align-items-center justify-content-center fw-bold'"
                        [ngStyle]="isOutputOn === true
                          ? {'border-color': '#e3e330', 'background-color': 'rgba(227, 227, 48, 0.1)', 'color': '#e3e330'}
                          : {}"
                        [style.cursor]="isPermanentLocked ? 'not-allowed' : 'pointer'"
                        [style.opacity]="isPermanentLocked ? 0.6 : 1"
                        [attr.title]="isPermanentLocked ? ('channelsPermanent' | translate) : null"
                        style="min-width: 80px; height: 32px; font-size: 0.9rem;">
                        <ng-container *ngIf="isOutputOn === true">{{ 'on' | translate }}</ng-container>
                        <ng-container *ngIf="isOutputOn === false">{{ 'off' | translate }}</ng-container>
                        <ng-container *ngIf="isOutputOn === null">--</ng-container>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-6 border-start">
                  <div class="data-item text-center px-2">
                    <div class="data-icon bg-info bg-opacity-10 mx-auto mb-2">
                      <i class="fas fa-clock text-info"></i>
                    </div>
                    <div class="data-content text-center">
                      <div class="data-value">{{ view.total != null ? (view.total | number:'1.0-1') + ' h' : '--' }}</div>
                      <small class="data-label">{{ 'totalHours' | translate }}</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card flex-grow-1 d-flex flex-column astro-lum-status-card">
        <div class="card-header py-2 flex-shrink-0 d-flex align-items-center justify-content-between">
          <h6 class="card-title mb-0">{{ 'status' | translate }}</h6>
        </div>

        <div class="astro-lum-alarm-strip flex-shrink-0 px-3" *ngIf="!loading && AlarmsTriggered.length > 0">
          <div class="astro-lum-alarm-banner d-flex align-items-center flex-wrap gap-2 py-2 px-3 small" role="status">
            <i class="fas fa-exclamation-triangle flex-shrink-0" aria-hidden="true"></i>
            <span class="fw-semibold">{{ 'lumAlarmsTriggered' | translate }}</span>
            <button
              type="button"
              class="badge rounded-pill bg-primary border-0 astro-lum-alarm-badge"
              *ngFor="let alarm of AlarmsTriggered"
              [ngbPopover]="alarmDetail"
              [popoverTitle]="alarm.cfg?.name"
              [popoverContext]="{ alarm: alarm }"
              triggers="mouseenter:mouseleave focus"
              placement="bottom"
              container="body"
              [openDelay]="200"
              [closeDelay]="120">
              {{ alarm.cfg?.name }}
            </button>
          </div>
        </div>

        <ng-template #alarmDetail let-alarm="alarm">
          <div class="small">
            <div class="mb-1">
              <span class="text-muted">{{ 'lumAlarmVariable' | translate }}</span>
              <span class="ms-1">{{ alarmVariableKey(alarm) ? (alarmVariableKey(alarm) | translate) : '--' }}</span>
            </div>
            <div class="mb-1">
              <span class="text-muted">{{ 'lumAlarmCondition' | translate }}</span>
              <span class="ms-1">{{ alarmConditionText(alarm) }}</span>
            </div>
            <div>
              <span class="text-muted">{{ 'lumAlarmAction' | translate }}</span>
              <span class="ms-1">{{ alarmActionKey(alarm) | translate }}</span>
              <span class="text-muted" *ngIf="alarmRelayActionKey(alarm) as relayAction"> ({{ relayAction | translate }})</span>
            </div>
          </div>
        </ng-template>

        <div class="card-body d-flex align-items-center justify-content-center flex-grow-1" *ngIf="loading">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">{{ 'loading' | translate }}</span>
          </div>
        </div>

        <div class="card-body astro-lum-chart-body flex-grow-1 d-flex flex-column" *ngIf="!loading">
          <app-scheduler-lum
            class="astro-lum-scheduler"
            [rtcData]="rtcData"
            [astcalData]="astcalData"
            [sunTimesData]="sunTimesData"
            [timeZone]="timeZone"
            [scheduleData]="scheduleData"
            chartIdPrefix="astro-lum-status">
          </app-scheduler-lum>
        </div>
      </div>
    </div>

    <div class="col-xl-4 col-lg-5 col-12 align-self-start">
      <div class="card w-100">
        <div class="card-header py-2">
          <h6 class="card-title mb-0">{{ 'instantaneousParameters' | translate }}</h6>
        </div>
        <div class="card-body py-3 d-flex flex-column gap-2">
          <div class="data-item d-flex align-items-center justify-content-between gap-3" *ngFor="let param of electricalParams">
            <div class="d-flex align-items-center gap-2 min-w-0">
              <div class="data-icon bg-opacity-10" [ngClass]="param.bg">
                <i class="fas" [ngClass]="param.icon"></i>
              </div>
              <span class="small text-muted text-truncate">{{ param.labelKey | translate }}</span>
            </div>
            <span class="fw-semibold text-end text-nowrap">
              {{ param.value ?? '--' }}<ng-container *ngIf="param.unit && param.value != null"> {{ param.unit }}</ng-container>
            </span>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>

<!-- Contadores de mantenimiento: ocultos. Las horas totales se muestran junto al estado de la salida. -->
<ng-container *ngIf="false">
  <div class="card">
    <div class="card-header py-2 d-flex align-items-center justify-content-between gap-2">
      <h6 class="card-title mb-0">{{ 'counters' | translate }}</h6>
      <div class="d-flex align-items-center gap-2">
        <span class="badge" *ngIf="maintenanceEnabled" [ngClass]="view.pending ? 'bg-danger' : 'bg-success'">
          <i class="fas me-1" [ngClass]="view.pending ? 'fa-triangle-exclamation' : 'fa-check'"></i>
          {{ (view.pending ? 'maintenancePending' : 'maintenanceUpToDate') | translate }}
        </span>
        <div class="form-check form-switch mb-0 d-flex align-items-center gap-1">
          <input class="form-check-input mt-0" type="checkbox" role="switch" id="maintenanceEnabled"
            [(ngModel)]="maintenanceEnabled">
          <label class="form-check-label small" for="maintenanceEnabled">{{ 'maintenance' | translate }}</label>
        </div>
      </div>
    </div>

    <div class="card-body py-3" *ngIf="!maintenanceEnabled">
      <div class="d-flex justify-content-center">
        <div class="data-item text-center">
          <div class="data-icon bg-info bg-opacity-10 mx-auto mb-2">
            <i class="fas fa-lightbulb text-info"></i>
          </div>
          <div class="data-value">{{ view.total != null ? (view.total | number:'1.0-1') + ' h' : '--' }}</div>
          <small class="data-label">{{ 'output1' | translate }}</small>
        </div>
      </div>
    </div>

    <div class="card-body py-2" *ngIf="maintenanceEnabled">

      <div class="d-flex justify-content-center gap-1 mb-3" *ngIf="showPreview">
        <button type="button" class="btn btn-sm" [ngClass]="preview === null ? 'btn-secondary' : 'btn-outline-secondary'" (click)="preview = null">Real</button>
        <button type="button" class="btn btn-sm" [ngClass]="preview === 'ok' ? 'btn-secondary' : 'btn-outline-secondary'" (click)="preview = 'ok'">Al día</button>
        <button type="button" class="btn btn-sm" [ngClass]="preview === 'near' ? 'btn-secondary' : 'btn-outline-secondary'" (click)="preview = 'near'">Cerca</button>
        <button type="button" class="btn btn-sm" [ngClass]="preview === 'pending' ? 'btn-secondary' : 'btn-outline-secondary'" (click)="preview = 'pending'">Pendiente</button>
      </div>

      <h6 class="text-muted small mb-2 text-center">{{ 'maintenanceCounter' | translate }}</h6>
      <div class="text-center mb-2">
        <span class="fs-3 fw-bold" [ngClass]="'text-' + view.tone">
          {{ view.hours != null ? (view.hours | number:'1.2-2') : '--' }}
        </span>
        <span class="text-muted ms-1">h</span>
        <span class="text-muted small ms-2" *ngIf="view.limit">/ {{ view.limit | number:'1.0-2' }} h</span>
      </div>

      <ng-container *ngIf="view.limit; else noLimit">
        <div class="progress" style="height: 10px;">
          <div class="progress-bar" [ngClass]="'bg-' + view.tone" role="progressbar"
            [style.width.%]="view.percent"></div>
        </div>
        <div class="d-flex justify-content-between small text-muted mt-1">
          <span>{{ view.percent | number:'1.0-0' }} %</span>
          <span *ngIf="view.remaining != null && view.remaining > 0">
            {{ 'maintenanceRemaining' | translate }}: {{ view.remaining | number:'1.0-2' }} h
          </span>
          <span class="text-danger fw-semibold" *ngIf="view.remaining != null && view.remaining <= 0">
            {{ 'maintenanceExceeded' | translate }}: {{ -view.remaining | number:'1.0-2' }} h
          </span>
        </div>
      </ng-container>
      <ng-template #noLimit>
        <div class="text-center small text-muted">{{ 'maintenanceNoLimit' | translate }}</div>
      </ng-template>

      <hr class="my-3">

      <label class="form-label small fw-semibold mb-1" for="maintenanceLimit">{{ 'maintenanceLimit' | translate }}</label>
      <div class="input-group input-group-sm mb-3">
        <input id="maintenanceLimit" type="number" min="1" step="1" class="form-control"
          [(ngModel)]="limitDraft" [placeholder]="view.limit ? (view.limit | number:'1.0-2') : '--'">
        <span class="input-group-text">h</span>
        <button type="button" class="btn btn-primary" [disabled]="!canSaveLimit" (click)="saveLimit()">
          {{ 'save' | translate }}
        </button>
      </div>

      <div *ngIf="!confirmingReset">
        <button type="button" class="btn btn-sm btn-outline-danger w-100" (click)="confirmingReset = true">
          <i class="fas fa-rotate-left me-1"></i>{{ 'maintenanceReset' | translate }}
        </button>
      </div>
      <div class="alert alert-warning py-2 mb-0 small" *ngIf="confirmingReset">
        <div class="mb-2">{{ 'maintenanceResetConfirm' | translate }}</div>
        <div class="d-flex gap-2">
          <button type="button" class="btn btn-sm btn-danger flex-fill" (click)="confirmReset()">{{ 'maintenanceReset' | translate }}</button>
          <button type="button" class="btn btn-sm btn-light flex-fill" (click)="confirmingReset = false">{{ 'cancel' | translate }}</button>
        </div>
      </div>

      <hr class="my-3">

      <div class="d-flex justify-content-between align-items-center small">
        <span><i class="fas fa-clock text-info me-1"></i><strong>{{ 'maintenanceTotalHours' | translate }}</strong></span>
        <span class="text-muted">{{ view.total != null ? (view.total | number:'1.2-2') + ' h' : '--' }}</span>
      </div>
    </div>
  </div>
</ng-container>
